<div class="ap-hint-dialog-container ap-p-3 ap-bg-white">
  <mat-dialog-content>
    <div [innerHTML]="data.hint|safeHtml"></div>
  </mat-dialog-content>
  <div>
    <button mat-button mat-dialog-close ap-bg-white><mat-icon>close</mat-icon></button>
  </div>
</div>